import { Button, Form, Modal, Select } from 'antd';
import Title from 'antd/es/typography/Title';
import React, { useEffect, useState } from 'react';
import { FieldBox, FlexWrapper } from '../../theme/common_style';
import { DropdownIconNew } from '../../theme/SvgIcons';
import PropTypes from 'prop-types';
import { assignDevice, getAllEmployees, getDeviceListing } from '../../services/api_collection';
import { toast } from 'react-toastify';
import { getFullName } from '../../utils/common_functions';
import { AvatarSelect } from '../../components/common/AvatarSelect';
import { useLocation } from 'react-router-dom';
import { useResponsiveModalWidth } from '../../hooks/useResponsiveModalWidth';

const AssignDeviceModal = ({ open, onClose, handleDetails }) => {
  const [loading, setLoading] = useState(false);
  const [employeeListing, setEmployeeListing] = useState([]);
  const [employeeLoader, setEmployeeLoader] = useState(false);
  const [deviceListing, setDeviceListing] = useState([]);
  const location = useLocation();
  const { id } = location.state || {};
  const [form] = Form.useForm();

  const width = useResponsiveModalWidth(500);

  const onFinish = async (values) => {
    try {
      setLoading(true);
      let res = await assignDevice(values?.assignee, values?.device_id);
      if (res?.statusCode === 200) {
        toast.success(res?.message);
        onClose();
        handleDetails();
      } else {
        toast.error(
          res?.response?.data?.message || res?.error || res?.message || 'Something went wrong'
        );
      }
    } catch (error) {
      toast.error(error || 'Something went wrong!');
    } finally {
      setLoading(false);
    }
  };

  const handleGetAllEmployee = async () => {
    setEmployeeLoader(true);
    let res = await getAllEmployees();
    if (res?.statusCode === 200) {
      setEmployeeLoader(false);
      setEmployeeListing(
        res?.data?.map((val) => ({
          label: getFullName(val?.first_name, val?.middle_name, val?.last_name),
          value: val?.id
        }))
      );
    } else {
      setEmployeeLoader(false);
      toast.error(
        res?.response?.data?.message || res?.error || res?.message || 'Something went wrong'
      );
    }
  };

  const handleAllGetDeviceListing = async () => {
    let params = new URLSearchParams();
    params.append('limit', 200);
    params.append('pageNumber', 1);
    let res = await getDeviceListing(params);
    if (res?.statusCode === 200) {
      setDeviceListing(
        res?.data
          ?.filter((val) => val?.status === 'available')
          ?.map((item) => ({
            label: `${item?.device_type} - ${item?.device_id}`,
            value: item?.id
          }))
      );
    } else {
      setDeviceListing([]);
      toast.error(
        res?.response?.data?.message || res?.error || res?.message || 'Something went wrong'
      );
    }
  };

  useEffect(() => {
    handleGetAllEmployee();
    handleAllGetDeviceListing();

    if (id) {
      form.setFieldsValue({
        device_id: id
      });
    }
  }, []);

  return (
    <Modal
      open={open}
      maskClosable={false}
      onCancel={onClose}
      centered
      width={width}
      footer={null}
      prefixCls="antCustomModal">
      <Title level={4} style={{ margin: 0, textAlign: 'center' }}>
        Assign Device
      </Title>

      <Form form={form} onFinish={onFinish} style={{ margin: '28px 0' }}>
        {() => (
          <>
            <FieldBox>
              <label htmlFor="assignee">
                Assign To <span>*</span>
              </label>
              <Form.Item
                name="assignee"
                rules={[{ required: true, message: 'Assignee is required' }]}>
                <AvatarSelect
                  options={employeeListing}
                  placeholder="--Select Option--"
                  loading={employeeLoader}
                  isEmp={true}
                />
              </Form.Item>
            </FieldBox>
            <FieldBox>
              <label htmlFor="device_id">
                Device Name <span>*</span>
              </label>
              <Form.Item
                name="device_id"
                rules={[{ required: true, message: 'Device Name is required' }]}>
                <Select
                  prefixCls="form-select"
                  allowClear
                  showSearch
                  disabled={id}
                  defaultValue={id}
                  style={{ marginBottom: '10px' }}
                  notFoundContent={'No Device Available'}
                  suffixIcon={<DropdownIconNew />}
                  placeholder="--Select Option--"
                  options={deviceListing}
                  filterOption={(input, option) =>
                    option.label.toLowerCase().includes(input.toLowerCase())
                  }
                />
              </Form.Item>
            </FieldBox>

            <FlexWrapper justify={'end'} gap={'10px'} style={{ marginTop: '20px' }}>
              <Button
                loading={loading}
                onClick={form.submit}
                style={{ width: '140px' }}
                prefixCls="antCustomBtn">
                Save
              </Button>
            </FlexWrapper>
          </>
        )}
      </Form>
    </Modal>
  );
};

AssignDeviceModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  handleDetails: PropTypes.func
};

export default AssignDeviceModal;
